export default __webpack_public_path__ + "static/media/gallery - story - other (1)_03.1660ae34.jpg";